import { useIsDarkMode } from './useIsDarkMode.ts';
import { getCustomTheme, type CustomThemeResult } from './getCustomTheme.ts';

export const useCustomTheme = (
	backgroundColorRaw: string | null | undefined,
	highlightColorRaw: string | null | undefined,
): CustomThemeResult => {
	const isDarkMode = useIsDarkMode();
	return getCustomTheme({ backgroundColorRaw, highlightColorRaw, isDarkMode });
};
